import styled from 'styled-components/macro'
import { BrandColor, BrandColors } from 'style/BrandColors'
import { MoreInfo } from '../svgs/MoreInfo'

type ColorProps = Partial<{
  backgroundColor: BrandColor
  fontColor: BrandColor
}>

export const InfoText = styled.div<ColorProps>`
  ${({ backgroundColor, fontColor }) => `
    background-color: ${BrandColors[backgroundColor ?? 'lavender']};
    color: ${BrandColors[fontColor ?? 'darkPurple']};
  `}
  display: flex;
  align-items: center;
  padding: 24px;
  border-radius: var(--mantine-radius-md);
`

export const InfoIcon = styled(MoreInfo)`
  margin-right: 24px;
`
